import axiosInstance from 'axiosInstance';

export const fetchPublicPlans = async () => {
  const response = await axiosInstance.get('login/plans/public');
  return response.data;
};
